
import { http } from "../../../shared/api/http";
import { Order } from "../models/types";

export async function ordersDineIn(): Promise<Order[]|any> {
  const res = await http.get(`/waiter/orders/dine-in`);
  return res.data;
}